import { createSlice } from '@reduxjs/toolkit';

export const systemSlice = createSlice({
  name: 'systemSlice',
  initialState: {
    errors: [],
    noVersionError: false,
    provideAuthorizationConfig: false,
    NewAppVersion: false,
    doBootstrap: false,
    doGetUserCurrencies: false,
    downloadState: false,
    whatsapp: {
      isLogin: false,
      isLoading: false
    },
    isWebsocketConnected: false,
    webSocketData: null,
    shouldRefetchCustomers: false,
    tutorials: [],
    departmentId: localStorage.getItem('departmentId') || '',
    shortCutModalsStates: {
      cashTransaction: false,
      incomingDraft: false,
      outgoingDraft: false,
      bankTransaction: false,
      buyCurrency: false,
      transferBetweenAccounts: false,
      submitPerson: false
    },
    branchId: null,
    shouldRefetchBranches: false,
    bankAccountId: null,
    shouldRefetchBanks: false,
    isSidebarOpen: false
  },
  reducers: {
    setErrors: (state, action) => {
      // Handle both array and single error objects
      if (Array.isArray(action.payload)) {
        state.errors = action.payload;
      } else {
        // Single error object - ensure it has context field
        const errorWithContext = {
          templateId: action.payload.templateId,
          metadata: action.payload.metadata,
          context: action.payload.context || null
        };
        state.errors = [errorWithContext];
      }
    },
    setNoVersionError: (state, action) => {
      state.noVersionError = action.payload;
    },
    setProvideAuthorizationConfig: (state, action) => {
      state.provideAuthorizationConfig = action.payload;
    },
    setNewAppVersion: (state, action) => {
      state.NewAppVersion = action.payload;
    },
    setDoBootstrap: (state, action) => {
      state.doBootstrap = action.payload;
    },
    updateUserCurrencies: (state, action) => {
      state.doGetUserCurrencies = action.payload;
    },
    setDownloadState: (state, action) => {
      state.downloadState = action.payload;
    },
    setWhatsappLoginState: (state, action) => {
      state.whatsapp.isLogin = action.payload;
    },
    setWhatsappLoadingState: (state, action) => {
      state.whatsapp.isLoading = action.payload;
    },
    setConnectionStatus: (state, action) => {
      state.isWebsocketConnected = action.payload;
    },
    setwebSocketData: (state, action) => {
      state.webSocketData = action.payload;
    },
    setShouldRefetchCustomers: (state, action) => {
      state.shouldRefetchCustomers = action.payload;
    },
    updateTutorialState: (state, action) => {
      const { name, status } = action.payload; // Destructure name and status from action payload
      const existingTutorial = state.tutorials.find(
        (tutorial) => tutorial.name === name
      );

      if (existingTutorial) {
        // Update the status of the existing tutorial
        existingTutorial.status = status;
      } else {
        // Add a new tutorial to the array
        state.tutorials.push({ name, status });
      }
    },
    setDepartmentId: (state, action) => {
      state.departmentId = action.payload;
    },
    setShortcutModalState: (state, action) => {
      const { modalName, value } = action.payload;
      if (modalName in state.shortCutModalsStates) {
        state.shortCutModalsStates[modalName] = value;
      }
    },
    setBranchId: (state, action) => {
      state.branchId = action.payload;
    },
    setShouldRefetchBranches: (state, action) => {
      state.shouldRefetchBranches = action.payload;
    },
    setBankAccountId: (state, action) => {
      state.bankAccountId = action.payload;
    },
    setShouldRefetchBanks: (state, action) => {
      state.shouldRefetchBanks = action.payload;
    },
    setIsDrawerOpen: (state, action) => {
      state.isSidebarOpen = action.payload;
    }
  }
});

export const {
  setErrors,
  setNoVersionError,
  setProvideAuthorizationConfig,
  setDoBootstrap,
  updateUserCurrencies,
  setNewAppVersion,
  setDownloadState,
  setWhatsappLoginState,
  setWhatsappLoadingState,
  setConnectionStatus,
  setwebSocketData,
  updateTutorialState,
  setDepartmentId,
  setShortcutModalState,
  setShouldRefetchCustomers,
  setBranchId,
  setShouldRefetchBranches,
  setBankAccountId,
  setShouldRefetchBanks,
  setIsDrawerOpen
} = systemSlice.actions;
export default systemSlice.reducer;
